import { RootState } from 'store';
import ICompanyContact from 'types/company/contact/ICompanyContact';

export const companyContactStateSelector = (state: RootState): ICompanyContact => state.contact.companyContact;
export const companyContactErrorSelector = (state: RootState): boolean => state.contact.companyContactError;
export const companyContactUpdateSuccessfulSelector = (state: RootState): boolean =>
  state.contact.companyContactUpdateSuccessful;

export const companyContactLoadingSelector = (state: RootState): boolean => state.contact.loading;
